import MechanicUserList from "./MechanicUserList";

const MechanicUser = (props) => {
  return <MechanicUserList {...props} />;
};

export default MechanicUser;
